'use client';

import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';

import MuiXLicense from './MuiXLicense';
import { theme } from './theme';

import type { ReactNode } from 'react';

type ThemeProviderProps = {
    children: ReactNode;
};

export function ThemeProvider({ children }: ThemeProviderProps) {
    return (
        <MuiThemeProvider theme={theme}>
            <CssBaseline />
            <MuiXLicense />
            {children}
        </MuiThemeProvider>
    );
}
